import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Explore Careers | Ship&Play',
  description:
    "We're making travel easier and more fun for everyone. Explore open roles at " +
    'Ship&Play and discover your next great opportunity.',
  alternates: {
    canonical: 'https://www.shipplay.com/careers',
  },
}

export default metadata
